import { createClient } from '@supabase/supabase-js';
import { appConfig } from './config';

/**
 * Browser client. Authentication, workspace selection, Storage and the normal
 * admin data plane use the caller's JWT and database-enforced tenant boundary.
 * Database-only commands go through public.admin_rpc(); secret-bearing and
 * externally orchestrated work continues through the Cloudflare tool surface.
 */
export const supabase = createClient(appConfig.supabaseUrl, appConfig.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});

export async function accessToken(): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}
